import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import { Box, Drawer, Typography, Avatar, Stack } from '@mui/material';

import bgImage from '../../../assets/rms/navbar-bg.png'
import NavSection from '../../../components/nav-section';
//

import { superAdminNavConfig} from './config';

// ----------------------------------------------------------------------


const StyledAccount = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 2.5),
}));

// ----------------------------------------------------------------------

Nav.propTypes = {
  openNav: PropTypes.bool,
  onCloseNav: PropTypes.func,
};

export default function Nav({ openNav, onCloseNav }) {
  const { pathname } = useLocation();

  const navigate = useNavigate()
  const loggedUser = useSelector((state) => state.adminUser.user)
  const currentEnvironment = useSelector((state) => state.environment.currentEnvironment)
  console.log(loggedUser)

  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const renderContent = (

    <Stack sx={{ display: 'flex', justifyContent: 'space-between', height: '100%', backgroundColor: '#000', opacity: 0.9 }} >
      <Box sx={{ mt: 4, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', }} >
        <Box onClick={() => navigate('dashboard')} sx={{cursor:'pointer'}}>
          <Typography variant='h1' color={'white'}>RMS</Typography>
          <Typography variant='body1' color={'white'}>{currentEnvironment}</Typography>
        </Box>
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <NavSection data={superAdminNavConfig}  role ={loggedUser?.role}/>
      </Box>


      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>

        <StyledAccount>
          <Avatar  alt={loggedUser?.firstName} sx={{ bgcolor: '#fff', color: '#7A7A7A' }} />

          <Box sx={{ ml: 2 }}>

                <Typography variant="body1" sx={{ color: '#fff' }}>
                  {loggedUser?.firstName} {loggedUser?.lastName}
                </Typography>
                <Typography variant="subtitle2" sx={{ color: '#fff' }}>
                  {loggedUser?.role}
                </Typography>

          </Box>
        </StyledAccount>

      </Box>
    </Stack>

  );


  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: '20%' },
        backgroundColor: '#000'
      }}
    >

        <Drawer
          open
          variant="permanent"
          PaperProps={{
            sx: {
              width: '20%',
              backgroundImage: `url(${bgImage})`,
            },
          }}
        >
          {renderContent}
        </Drawer>

    </Box>
  );
}
